import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboConsultaBancoComponent} from './combo-consulta-banco.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboConsultaBancoComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboConsultaBancoComponent]
})
export class ComboConsultaBancoModule {
}
